import { PaymentElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { useContext } from 'react';
import { PriceContext } from './context';
import { Routes, Route , useNavigate, NavLink,Link} from "react-router-dom";
import axios from 'axios';

export default function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();
  const { price, email,teams } = useContext(PriceContext);

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  console.log(teams)
  function startpayment(price, email, teams){
  


      axios({
        method: 'post',
        url: `https://82jsvqje43.execute-api.us-east-2.amazonaws.com/wnba_dev/credits`,
       
        withCredentials: false,
        data: {
          email:email,
          path:'payment-start',
          teams:teams,
          amount:price
        },
      }).then(function (response) {
         const data = response.data;
        let credits_purchased = Number(data);

      })
      .catch(function (error) {
      });










  }

  const handleSubmit = async (e) => {
    e.preventDefault();
     startpayment(price, email,teams)

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);
    console.log('payed')

    const { error , paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: `${window.location.origin}/account`
      },
         redirect: 'if_required', 
    });

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
      } else {
        setMessage(error.message);
      }
    } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      setMessage("Payment successful!");
      navigate('/account')
      // Add logic here to handle the case when the payment goes through
      console.log("Payment succeeded:", paymentIntent);

      // Your additional logic here for payment success
    } else {
      setMessage("An unexpected status was returned.");
    }

    setIsProcessing(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />
      <button disabled={isProcessing || !stripe || !elements} id="submit">
        <span id="button-text">
          {isProcessing ? "Processing ... " : "Pay now"}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
